module.exports = __webpack_public_path__ + "img/business-and-finance.cb30f8ff.png";